import { ArrowRightOutlined, ToolOutlined } from "@ant-design/icons";
import { Alert, Button } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import type { MyPortalSummary } from "../../service/onboarding.service";

/**
 * In-app pointer to the group's onboarding portal, so a logged-in admin doesn't have to dig their link out of their
 * inbox.
 */
export default function SetupTrackerBanner() {
  const [summary, setSummary] = useState<MyPortalSummary | null>(null);

  useEffect(() => {
    let cancelled = false;
    axiosInstance
      .get<MyPortalSummary>("/onboarding/my-portal/")
      .then(({ data }) => {
        if (!cancelled) setSummary(data);
      })
      .catch(() => {
        // A convenience, and not every user has a portal — stay silent.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!summary?.has_portal || summary.is_complete) return null;

  const actionNeeded = summary.action_needed === true;

  return (
    <Alert
      type={actionNeeded ? "warning" : "info"}
      showIcon
      icon={<ToolOutlined />}
      closable
      style={{ marginBottom: 16, padding: "8px 12px", textAlign: "left" }}
      message={
        <span style={{ fontSize: 13 }}>
          <strong>
            {actionNeeded
              ? "Your Nudge onboarding needs one thing from you"
              : `Nudge onboarding — ${summary.completed} of ${summary.total} steps done`}
          </strong>
          <span style={{ opacity: 0.75 }}>
            {actionNeeded ? " — open it to see what we're waiting on." : " — nothing needed from you right now."}
          </span>
        </span>
      }
      action={
        <Button size="small" type="primary" href={summary.url} target="_blank" rel="noopener noreferrer">
          Open onboarding <ArrowRightOutlined />
        </Button>
      }
    />
  );
}
